import { Utils } from "../../common/views/Utils";
import { IPictureService } from "../../pictures/viewmodels/PictureVM";
import { EditPictureModel } from "../../pictures/models/PictureModel";
import { NewFeedAdminService } from "./NewFeedService";

export class NewFeedPictureService implements IPictureService {
    private service = new NewFeedAdminService();

    public getList(ownerId: number): JQueryPromise<any> {
        return this.service.getPictures(ownerId);
    }

    public delete(ownerId: number, id: number): JQueryPromise<any> {
        return this.service.deletePicture(ownerId, id);
    }

    public create(ownerId: number, model: FormData): JQueryPromise<any> {
        return Utils.postFormData(model, this.service.RouteCreatePictures(ownerId));
    }

    public edit(ownerId: number, picture: EditPictureModel): JQueryPromise<any> {
        return this.service.editPicture(ownerId, picture);
    }

    public editList(ownerId: number, pictures: EditPictureModel[]): JQueryPromise<any> {
        return this.service.editPictures(ownerId, pictures);
    }
}